import { useMemo } from 'react'

import { useQuery } from 'react-query'

import {
  CustomField,
  type CustomFieldConstructorData,
} from '@webapp/core/entities/internal/CustomField'
import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'

export interface POCustomFieldConfigListParams {
  page: number
  pageSize: number
}

type UseQueryPOCustomFieldConfigsReturn = {
  fields: CustomField[]
  pagination: {
    count: number
    numPages: number
    currentPage: number
  }
  isLoading: boolean
  isFetching: boolean
  error: RepoError | null
}

export const useQueryPOCustomFieldConfigs = (
  params: POCustomFieldConfigListParams
): UseQueryPOCustomFieldConfigsReturn => {
  const { data, isLoading, isFetching, error } = useQuery<
    RepoPaginatedResponse<CustomFieldConstructorData>,
    RepoError
  >(
    customFieldQueryConfig.getPurchaseOrderCustomFields({
      meta__is_active: 'True',
      page: params.page,
      page_size: params.pageSize,
    })
  )

  const fields = useMemo(
    () => (data?.data ?? []).map((cf) => new CustomField(cf)),
    [data]
  )

  return {
    fields,
    pagination: {
      count: data?.pagination?.count ?? 0,
      numPages: data?.pagination?.numPages ?? 0,
      currentPage: data?.pagination?.page ?? params.page,
    },
    isLoading,
    isFetching,
    error: error ?? null,
  }
}
